module.exports = __webpack_public_path__ + "img/svg/footer-section-active-background.6bbe1d17d880b5eb330f9b2d07f736c6.svg";